import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from "prop-types";
import { Flex } from "@base-ui/containers";
import { StyledInput } from "./textInput.styles";
import { Label } from "@base-ui/text";
import { useInput } from "hooks";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var styledSystemKeys = ["space", "layout", "flexbox", "color"];
var TextInput = function TextInput(props) {
  var id = props.id,
    value = props.value,
    label = props.label,
    onChange = props.onChange,
    _props$isControlled = props.isControlled,
    isControlled = _props$isControlled === void 0 ? true : _props$isControlled,
    textRef = props.textRef,
    hideLabel = props.hideLabel,
    autoFocus = props.autoFocus,
    placeholder = props.placeholder,
    disabled = props.disabled,
    maxLength = props.maxLength,
    _onKeyPress = props.onKeyPress,
    className = props.className,
    inverted = props.inverted,
    styleAs = props.styleAs,
    error = props.error,
    errorMessage = props.errorMessage,
    ariaControls = props.ariaControls,
    ariaAutocomplete = props.ariaAutocomplete,
    ariaActivedescendant = props.ariaActivedescendant,
    ariaHasPopup = props.ariaHasPopup;
  var _useInput = useInput(value, onChange, isControlled),
    inputString = _useInput.inputString,
    onInput = _useInput.onInput;
  return /*#__PURE__*/_jsxs(Flex.Column, _objectSpread(_objectSpread({
    className: className
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: [/*#__PURE__*/_jsx(Label, {
      htmlFor: id,
      hideLabel: hideLabel,
      inverted: inverted,
      disabled: disabled,
      children: error && errorMessage ? errorMessage : label
    }), /*#__PURE__*/_jsx(StyledInput, {
      id: id,
      type: "text",
      error: error,
      ref: textRef || undefined,
      "aria-controls": ariaControls || undefined,
      "aria-autocomplete": ariaAutocomplete || undefined,
      "aria-activedescendant": ariaActivedescendant || undefined,
      "aria-haspopup": ariaHasPopup || undefined,
      value: inputString || "",
      styleAs: styleAs,
      autoFocus: autoFocus,
      onChange: function onChange(e) {
        return onInput(e.target.value);
      },
      onKeyPress: function onKeyPress(e) {
        return _onKeyPress && _onKeyPress(e);
      },
      placeholder: placeholder,
      disabled: disabled,
      inverted: inverted,
      maxLength: maxLength
    })]
  }));
};
TextInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  hideLabel: PropTypes.bool,
  inverted: PropTypes.bool,
  textRef: PropTypes.any,
  autoFocus: PropTypes.bool,
  maxLength: PropTypes.number,
  onKeyPress: PropTypes.func,
  className: PropTypes.string,
  styleAs: PropTypes.string,
  error: PropTypes.bool,
  errorMessage: PropTypes.string
};
export default TextInput;